var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c("div", { staticClass: "row mt-8" }, [
          _c("div", { staticClass: "col-sm-12" }, [
            _c("div", { staticClass: "container-fluid" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col" }, [
                  _c("div", { staticClass: "card" }, [
                    _c(
                      "div",
                      { staticClass: "card-body" },
                      [
                        _c("font", { attrs: { size: "6" } }, [
                          _vm._v("Menú de acceso rápido")
                        ])
                      ],
                      1
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "container-fluid" }, [
              _vm.arrayBarra[0]["state"] === true ||
              _vm.arrayBarra[1]["state"] === true ||
              _vm.arrayBarra[2]["state"] === true
                ? _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _vm.arrayBarra[0]["state"] === true
                          ? _c(
                              "router-link",
                              {
                                staticClass: "card sombra zoom",
                                attrs: { to: "/admin/cuentas" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-body",
                                    attrs: { align: "center" }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "img-fluid",
                                      attrs: {
                                        src:
                                          "/assets/img/menu/contabilidad.png",
                                        height: "100",
                                        width: "100"
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-footer",
                                    attrs: { align: "center" }
                                  },
                                  [
                                    _c("font", { staticClass: "letra" }, [
                                      _vm._v("CUENTAS")
                                    ])
                                  ],
                                  1
                                )
                              ]
                            )
                          : _c(
                              "router-link",
                              {
                                staticClass: "card sombra zoom",
                                attrs: { to: "/admin/menu" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-body",
                                    attrs: { align: "center" }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "img-fluid",
                                      attrs: {
                                        src: "/assets/img/menu/prohibicion.png",
                                        height: "100",
                                        width: "100"
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-footer",
                                    attrs: { align: "center" }
                                  },
                                  [
                                    _c("font", { staticClass: "letra" }, [
                                      _vm._v("SIN PERMISOS")
                                    ])
                                  ],
                                  1
                                )
                              ]
                            )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _vm.arrayBarra[1]["state"] === true
                          ? _c(
                              "router-link",
                              {
                                staticClass: "card sombra zoom",
                                attrs: { to: "/admin/cajas" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-body",
                                    attrs: { align: "center" }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "img-fluid",
                                      attrs: {
                                        src: "/assets/img/menu/dinero.png",
                                        height: "100",
                                        width: "100"
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-footer",
                                    attrs: { align: "center" }
                                  },
                                  [
                                    _c("font", { staticClass: "letra" }, [
                                      _vm._v("CAJAS")
                                    ])
                                  ],
                                  1
                                )
                              ]
                            )
                          : _c(
                              "router-link",
                              {
                                staticClass: "card sombra zoom",
                                attrs: { to: "/admin/menu" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-body",
                                    attrs: { align: "center" }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "img-fluid",
                                      attrs: {
                                        src: "/assets/img/menu/prohibicion.png",
                                        height: "100",
                                        width: "100"
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-footer",
                                    attrs: { align: "center" }
                                  },
                                  [
                                    _c("font", { staticClass: "letra" }, [
                                      _vm._v("SIN PERMISOS")
                                    ])
                                  ],
                                  1
                                )
                              ]
                            )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _vm.arrayBarra[2]["state"] === true
                          ? _c(
                              "router-link",
                              {
                                staticClass: "card sombra zoom",
                                attrs: { to: "/admin/products/productos" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-body",
                                    attrs: { align: "center" }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "img-fluid",
                                      attrs: {
                                        src: "/assets/img/menu/productos.png",
                                        height: "100",
                                        width: "100"
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-footer",
                                    attrs: { align: "center" }
                                  },
                                  [
                                    _c("font", { staticClass: "letra" }, [
                                      _vm._v("PRODUCTOS")
                                    ])
                                  ],
                                  1
                                )
                              ]
                            )
                          : _c(
                              "router-link",
                              {
                                staticClass: "card sombra zoom",
                                attrs: { to: "/admin/menu" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-body",
                                    attrs: { align: "center" }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "img-fluid",
                                      attrs: {
                                        src: "/assets/img/menu/prohibicion.png",
                                        height: "100",
                                        width: "100"
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-footer",
                                    attrs: { align: "center" }
                                  },
                                  [
                                    _c("font", { staticClass: "letra" }, [
                                      _vm._v("SIN PERMISOS")
                                    ])
                                  ],
                                  1
                                )
                              ]
                            )
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-8" }, [
          _c("div", { staticClass: "col-sm-12" }, [
            _c("div", { staticClass: "container-fluid" }, [
              _vm.arrayBarra[3]["state"] === true ||
              _vm.arrayBarra[4]["state"] === true ||
              _vm.arrayBarra[5]["state"] === true
                ? _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _vm.arrayBarra[4]["state"] === true
                          ? _c(
                              "router-link",
                              {
                                staticClass: "card sombra zoom",
                                attrs: { to: "/admin/personas/empleados" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-body",
                                    attrs: { align: "center" }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "img-fluid",
                                      attrs: {
                                        src: "/assets/img/menu/empleados.png",
                                        height: "100",
                                        width: "100"
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-footer",
                                    attrs: { align: "center" }
                                  },
                                  [
                                    _c("font", { staticClass: "letra" }, [
                                      _vm._v("EMPLEADOS")
                                    ])
                                  ],
                                  1
                                )
                              ]
                            )
                          : _c(
                              "router-link",
                              {
                                staticClass: "card sombra zoom",
                                attrs: { to: "/admin/menu" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-body",
                                    attrs: { align: "center" }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "img-fluid",
                                      attrs: {
                                        src: "/assets/img/menu/prohibicion.png",
                                        height: "100",
                                        width: "100"
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-footer",
                                    attrs: { align: "center" }
                                  },
                                  [
                                    _c("font", { staticClass: "letra" }, [
                                      _vm._v("SIN PERMISOS")
                                    ])
                                  ],
                                  1
                                )
                              ]
                            )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _vm.arrayBarra[5]["state"] === true
                          ? _c(
                              "router-link",
                              {
                                staticClass: "card sombra zoom",
                                attrs: { to: "/admin/personas/proveedores" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-body",
                                    attrs: { align: "center" }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "img-fluid",
                                      attrs: {
                                        src: "/assets/img/menu/grupo.png",
                                        height: "100",
                                        width: "100"
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-footer",
                                    attrs: { align: "center" }
                                  },
                                  [
                                    _c("font", { staticClass: "letra" }, [
                                      _vm._v("PROVEEDORES")
                                    ])
                                  ],
                                  1
                                )
                              ]
                            )
                          : _c(
                              "router-link",
                              {
                                staticClass: "card sombra zoom",
                                attrs: { to: "/admin/menu" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-body",
                                    attrs: { align: "center" }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "img-fluid",
                                      attrs: {
                                        src: "/assets/img/menu/prohibicion.png",
                                        height: "100",
                                        width: "100"
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-footer",
                                    attrs: { align: "center" }
                                  },
                                  [
                                    _c("font", { staticClass: "letra" }, [
                                      _vm._v("SIN PERMISOS")
                                    ])
                                  ],
                                  1
                                )
                              ]
                            )
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-8" }, [
          _c("div", { staticClass: "col-sm-12" }, [
            _c("div", { staticClass: "container-fluid" }, [
              _vm.arrayBarra[6]["state"] === true ||
              _vm.arrayBarra[7]["state"] === true ||
              _vm.arrayBarra[8]["state"] === true
                ? _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _vm.arrayBarra[6]["state"] === true
                          ? _c(
                              "router-link",
                              {
                                staticClass: "card sombra zoom",
                                attrs: { to: "/admin/venta/nuevo" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-body",
                                    attrs: { align: "center" }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "img-fluid",
                                      attrs: {
                                        src: "/assets/img/menu/rebaja.png",
                                        height: "100",
                                        width: "100"
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-footer",
                                    attrs: { align: "center" }
                                  },
                                  [
                                    _c("font", { staticClass: "letra" }, [
                                      _vm._v("VENTAS")
                                    ])
                                  ],
                                  1
                                )
                              ]
                            )
                          : _c(
                              "router-link",
                              {
                                staticClass: "card sombra zoom",
                                attrs: { to: "/admin/menu" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-body",
                                    attrs: { align: "center" }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "img-fluid",
                                      attrs: {
                                        src: "/assets/img/menu/prohibicion.png",
                                        height: "100",
                                        width: "100"
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-footer",
                                    attrs: { align: "center" }
                                  },
                                  [
                                    _c("font", { staticClass: "letra" }, [
                                      _vm._v("SIN PERMISOS")
                                    ])
                                  ],
                                  1
                                )
                              ]
                            )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _vm.arrayBarra[7]["state"] === true
                          ? _c(
                              "router-link",
                              {
                                staticClass: "card sombra zoom",
                                attrs: { to: "/admin/compra/nuevo" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-body",
                                    attrs: { align: "center" }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "img-fluid",
                                      attrs: {
                                        src: "/assets/img/menu/ventas.png",
                                        height: "100",
                                        width: "100"
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-footer",
                                    attrs: { align: "center" }
                                  },
                                  [
                                    _c("font", { staticClass: "letra" }, [
                                      _vm._v("COMPRAS")
                                    ])
                                  ],
                                  1
                                )
                              ]
                            )
                          : _c(
                              "router-link",
                              {
                                staticClass: "card sombra zoom",
                                attrs: { to: "/admin/menu" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-body",
                                    attrs: { align: "center" }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "img-fluid",
                                      attrs: {
                                        src: "/assets/img/menu/prohibicion.png",
                                        height: "100",
                                        width: "100"
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-footer",
                                    attrs: { align: "center" }
                                  },
                                  [
                                    _c("font", { staticClass: "letra" }, [
                                      _vm._v("SIN PERMISOS")
                                    ])
                                  ],
                                  1
                                )
                              ]
                            )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _vm.arrayBarra[8]["state"] === true
                          ? _c(
                              "router-link",
                              {
                                staticClass: "card sombra zoom",
                                attrs: { to: "/admin/reports" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-body",
                                    attrs: { align: "center" }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "img-fluid",
                                      attrs: {
                                        src: "/assets/img/menu/big-data.png",
                                        height: "100",
                                        width: "100"
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-footer",
                                    attrs: { align: "center" }
                                  },
                                  [
                                    _c("font", { staticClass: "letra" }, [
                                      _vm._v("REPORTES")
                                    ])
                                  ],
                                  1
                                )
                              ]
                            )
                          : _c(
                              "router-link",
                              {
                                staticClass: "card sombra zoom",
                                attrs: { to: "/admin/menu" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-body",
                                    attrs: { align: "center" }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "img-fluid",
                                      attrs: {
                                        src: "/assets/img/menu/prohibicion.png",
                                        height: "100",
                                        width: "100"
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-footer",
                                    attrs: { align: "center" }
                                  },
                                  [
                                    _c("font", { staticClass: "letra" }, [
                                      _vm._v("SIN PERMISOS")
                                    ])
                                  ],
                                  1
                                )
                              ]
                            )
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d932594e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d932594e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/admin/dashboard/Menu.vue
// module id = 443
// module chunks = 0